import { RouteConfig } from "../../types/RouteConfig";
import { biopakCashbackViewRoute } from "./biopak/routes";
import { nisbetsCashbackViewRoute } from "./nisbets/routes";
import { bookerVoucherRoute } from "./booker/routes";
import { calorRoutes } from "./calor/routes";
import { rewardsHomeRoute } from "./home/route";
import {rewardsSignupRoute} from "./signups/route";

export const rewardsRoutes: RouteConfig<'with-children'> = {
    name: 'Rewards',
    icon: 'mdi mdi-trophy-variant-outline',
    context: 'member',
    children: [
        rewardsHomeRoute,
        rewardsSignupRoute,
        biopakCashbackViewRoute,
        bookerVoucherRoute,
        calorRoutes,
        nisbetsCashbackViewRoute,
    ],
}